import { useState } from "react";
import { faqs } from "@/mocks/gua";
import SectionTitle from "./SectionTitle";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-start gap-8 px-4 md:px-6">
        <SectionTitle
          eyebrow="常见问题"
          title="吃瓜前，先把这些搞明白"
          desc="关于更新节奏、信息来源、转载与订阅的疑问，这里都有答案。"
          align="left"
        />

        <div className="flex w-full flex-col gap-3">
          {faqs.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-accent-300 bg-white" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenIndex(open ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="font-heading text-sm font-black text-foreground-900 md:text-base">{item.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-accent-500 text-white" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className={`ri-add-line text-lg transition-transform ${open ? "rotate-45" : ""}`} aria-hidden="true" />
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}